import React from 'react'
import { PieChart } from 'react-minimal-pie-chart'
import './CrossClientProgress.scss'

export interface CrossClientProgressProps {
  total: number
  done: number
  className?: string
  showPercentage?: boolean
  lineWidth?: number
}

export const CrossClientProgress: React.FC<CrossClientProgressProps> = ({ total, done, className, showPercentage = false, lineWidth = 30 }) => {
  const percentage = showPercentage ? Math.floor((done / total) * 100) : null

  return (
    <div className={`d-flex flex-column align-items-center justify-content-center position-relative ${className ?? ''}`}>
      <PieChart
        data={[
          { title: 'Done', value: done, color: 'var(--zocks-primary)' },
          { title: 'Total', value: total - done, color: '#E9ECEF' },
        ]}
        lineWidth={lineWidth}
        totalValue={total}
        startAngle={270}
      />
      {percentage ? (
        percentage >= 100 ? (
          <i className='bi bi-check-lg zocks-text-primary fs-4 position-absolute' />
        ) : (
          <div className='paragraph-medium medium position-absolute'>{percentage}%</div>
        )
      ) : null}
    </div>
  )
}
